// Shared constants for calendar-v2 grouping & sorting.

import type { Importance } from "../types";

/**
 * Classification priority order for grouping within a day (matches the
 * calendar's daily_markdown order): data > speaker > supply > earning > others.
 */
export const CLASSIFICATION_ORDER: Record<string, number> = {
  data: 0,
  speaker: 1,
  supply: 2,
  earning: 3,
  expiry: 4,
  ad_hoc: 5,
  holiday: 6,
};

/** Importance order for sorting (high first). */
export const IMPORTANCE_ORDER: Record<Importance | string, number> = {
  high: 0,
  normal: 1,
  low: 2,
};
